// translationFileProduct.tsx

import { ProductGroups } from 'enums';

/**
 * A helper function to get localized text with product-specific differentiation.
 * @param key - The translation key to look up.
 * @param productGroup - The current product group (e.g., 'Recruiting', 'LeadBooster').
 * @param t - The translation function from `react-i18next`.
 * @returns The localized string.
 */
const getLocalizedText = (key: string, productGroup: ProductGroups, t: (key: string) => string): string => {
  if (productGroup === ProductGroups.LEAD_BOOSTER) {
    const leadBoosterKey = `${key}_LeadBooster`;
    return t(leadBoosterKey) || t(key); // Fallback to the base key if the specific one doesn't exist
  }
  // Default is for Active Sourcing
  const activeSourcingKey = `${key}_ActiveSourcing`;
  return t(activeSourcingKey) || t(key);
};

export default getLocalizedText;
